import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=67cb5abc&scoped=true"
import script from "./AuditLogs.vue?vue&type=script&lang=js"
export * from "./AuditLogs.vue?vue&type=script&lang=js"
import style0 from "./AuditLogs.vue?vue&type=style&index=0&id=67cb5abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb5abc",
  null
  
)

export default component.exports